import Vue from 'vue'
import PaymentTransformer from '../../transformers/extranet/PaymentTransformer'

/**
 * @author Andrés Aguilar <andresyoshimar@gmail.com>
 */

const getPaymentsPerPackage = (packageId) => {
  let config = null
  if (packageId) {
    config = {
      params: { package: packageId },
    }
  }
  return Vue.$http.get('extranet/package/payments/', config)
    .then(response => PaymentTransformer.fetchCollection(response.data))
    .catch((err) => { throw err })
}

export default getPaymentsPerPackage


// WEBPACK FOOTER //
// ./src/services/extranet/getPaymentsPerPackage.js